import React, { useState } from "react";
import { Modal, Upload, Input, DatePicker, Select, message } from "antd";
import { Icon } from "@iconify/react";
import { saveClientData } from "../APIs/clientApis";
import Button from "../components/shared/button";
const { Dragger } = Upload;
const { Option } = Select;
const { TextArea } = Input;

const UploadDocModal = ({ isuploadModelOpen, setisuploadModelOpen, handleUpload }) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileList, setFileList] = useState([]);

  // Handle file selection
  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    setIsUploaded(fileList.length > 0);
  };

  // Automatically upload file when dropped
  const handleFileDrop = (e) => {
    const droppedFile = e.file;
    if (droppedFile) {
      setFileList([droppedFile]);  // Set file
      setIsUploaded(true);
      handleSubmit(droppedFile.originFileObj); // Upload immediately
    }
  };

  const handleSubmit = async () => {
    const uploadedFile = fileList.length > 0 ? fileList[0].originFileObj : null;
  
    if (!uploadedFile) {
      message.error("Please select a file first!");
      return;
    }
  
    console.log("Uploading file:", uploadedFile.name);
    console.log("Uploaded file:", uploadedFile);
  
    try {
      await handleUpload(uploadedFile);  
      setisuploadModelOpen(false);
      setFileList([]);  
      setIsUploaded(false);
      message.success("Document uploaded successfully!");
    } catch (error) {
      message.error("Upload failed. Try again!");
    }
  };
  
  const handleSaveClientData = async (data) => {
    console.log("🚀 Saving Client Data Function Called with:", data);
  
    if (!data || !data.analysis) {
      console.error("❌ Invalid Data Structure:", data);
      message.error("Upload response structure is incorrect!");
      return;
    }
  
    // ✅ Extract values from response
    const id_no = data.analysis.id_no;
    const upload_date = data.analysis.upload_date;
    const case_id = data.case_id;
  
    console.log("🔍 Extracted Data:", { id_no, upload_date, case_id });
  
    if (!id_no || !upload_date || !case_id) {
      console.error("❌ Missing Required Fields:", { id_no, upload_date, case_id });
      message.error("Required data is missing!");
      return;
    }
  
    try {
      const response = await saveClientData({ id_no, case_id, upload_date });
      console.log("✅ Save Response:", response);
  
      if (response) {
        message.success("Client data saved successfully!");
      }
    } catch (error) {
      console.error("❌ Failed to Save Client Data:", error);
      message.error("Failed to save client data. Try again!");
    }
  };
  
 
  
  

  // const handleSubmit = () => {
  //   setisuploadModelOpen(false);
  // };

  // const handleCancel = () => {
  //   setisuploadModelOpen(false);
  // };

  return (
    <Modal
      open={isuploadModelOpen}
      onCancel={() => setisuploadModelOpen(false)}
      // onCancel={handleCancel}
      className="del-modal "
      centered={true}
      width="65%"
    >
      <div className="modal-content rounded-[19px] min-h-[80vh] flex flex-col justify-between items-center py-[22px] px-[50px] max-sm:px-[20px]">
        <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
          Upload Document
        </h5>

        {!isUploaded ? (
          <Dragger
            name="file"
            multiple={false}
            fileList={fileList}
            onChange={handleUploadChange}
            beforeUpload={() => false}
            onDrop={handleFileDrop} 
            className="upload-div w-full max-w-[426px] mt-[14px] h-[226px] border-dashed border-[#999999] border-2 flex flex-col items-center justify-center rounded-[17px]"
          >
            <Icon
              icon="material-symbols:upload"
              width={60}
              height={60}
              color="#999999"
              className="m-auto "
            />
            <p className="medium text-[#999] font-semibold ">
              Browse file OR drag and drop
            </p>
            <p className="text-[#999] font-semibold e-small mt-1">
              Filetype: PDF, DOCX, PPT
            </p>
          </Dragger>
        ) : (
          <div className="form-view w-full mt-[14px] flex flex-col items-center space-y-[21px]">
            <div className="uploaded-file-preview pt-[19px] pb-[32px] px-[19px] flex flex-col items-center justify-between border-dashed border-[#999999] border-2 w-[285px] rounded-[17px]">
              <div className="relative">
                <img src="../../assets/images/dashboard/fileImg.png" alt="" />
                <Icon
                  icon="mdi:cross-circle"
                  width={22}
                  height={22}
                  color="#143A62"
                  className="cursor-pointer absolute top-[-4%] right-[-4%]"
                  onClick={() => {
                    setFileList([]);
                    setIsUploaded(false);
                  }}
                />
              </div>
              <p className="e-small font-semibold text-[#999] mt-[3px]">
                {fileList.length !== 0 &&
                  fileList[0].name.length > 20 &&
                  `${fileList[0].name.slice(0, 20)}...${fileList[0].name.slice(
                    -5
                  )}`}
              </p>
            </div>
          </div>
        )}
        <Button
          text={isUploaded ? "Save now" : "Next"}
          className="button btn-blue !rounded-[39px] large mt-[14px]"
          height={45}
          width={176}
          // onClick={isUploaded ? handleSubmit : null}
          onClick={isUploaded ? () => handleSubmit() : null}
        />
      </div>
    </Modal>
  );
};

export default UploadDocModal;
